module.exports = __webpack_public_path__ + "assets/img/chat.1136d7ed.svg";